export default {
  localHost: 'http://localhost:3000',
  // apiHost: 'https://epidash-dev-api.epinet-tx.org',
  apiHost: 'https://epidash-api.epinet-tx.org',
};

